import React from "react"

interface Props {
    onChange: React.MouseEventHandler
}

const CookieBox = ({ onChange }: Props) => {
    return (
        <div className="cookie-box fixed bottom-0 left-0 w-full bg-bg border-t border-medium z-50">
            <div className="large-container py-5 flex flex-wrap items-center justify-between">
                <p className="text-color-2 text-sm mr-6">
                    Ta strona używa plików cookies. Klikając OK, zgadzasz się na
                    ich używanie.
                </p>
                <button
                    className="btn btn-ghost mt-3 sm:mt-0"
                    style={{ height: "2.75rem", padding: "0 1.75rem" }}
                    onClick={onChange}
                >
                    <span>OK</span>
                </button>
            </div>
        </div>
    )
}

export default CookieBox
